<template>
  <div>
    <Summary backgroundColor="#778D96" class="is-header">
      <div slot="left">
        <h2 class="subtitle">Contact</h2>
        <div class="content">
          <p><a href="mailto:jaymillerarnold@gmail.com" style="color: #fff;">jaymillerarnold@gmail.com</a></p>
          <br>
        </div>

        <a :href="`${publicPath}JA-Resume.pdf`" target="_blank" class="button is-outlined is-white">Download Resume</a>
      </div>
      <div slot="right">
        <h2 class="subtitle">Summary</h2>
        <div class="content">
          <p>With over 11 years of experience in interactive and web design, I have been fortunate to work with a
            talented team for clients both large and small. I believe that for a great product, collaboration is key. By
            combining the goals of the client with a user centered focus, I strive to create impactful digital
            experiences.</p>
        </div>
      </div>
    </Summary>
    <div class="section">
      <div class="container">
        <div class="columns">
          <div class="column is-half">

            <h2 class="title">Experience</h2>
          </div>
          <div class="column is-half">
            <div class="content experience">
              <strong>
                Director of Digital — 5by5 - A Change Agency <br>
                2017—2018
              </strong>

              <p>Manage team of 4 developers; team responsible for full execution of all digital production</p>

              <p>Participate in strategy, planning and proposal meetings with clients and Senior Management</p>

              <p>Discovery, user experience and design for all clients</p>

              <p>Conduct user tests on all digital projects</p>

              <p>Responsible for Kick-off and client presentation meetings</p>

              <p>Implement and refine internal processes for maintenance, retainer, and new projects</p>
            </div>

          <div class="content experience">
            <strong>Owner/Creative Director — Jay Arnold Creative <br>
              2015—2017</strong>
            <p>User experience, discovery and design for all clients</p>

            <p>Work closely with clients to determine concept, creative scope, overall vision and manage production
              teams to accomplish client goals</p>

            <p>Managerial responsibilities included implementation of creative strategy for all projects by working with
              developers, project managers, copy writers and photographers</p>
          </div>
          <div class="content experience">
            <strong>Interactive Art Director — iDesign, Inc.
              2007—2015</strong>
            <p>User experience, discovery and design for all clients</p>

            <p>Lead a team of developers to insure consistency from wireframe design to launch</p>
          </div>
          </div>
        </div>
      </div>
    </div>
    <router-link to="/"><BigButton backgroundColor="#778D96" subtitle="View Work"></BigButton></router-link>
  </div>
</template>

<script>
  import Summary from '../components/Summary'
  import BigButton from '../components/BigAssButton'

  export default {
    components: {Summary, BigButton},
    data () {
      return {
        publicPath: process.env.BASE_URL
      }
    }
  }
</script>


<style lang="scss" scoped>

  .experience {
    font-family: 'Montserrat', sans-serif;
    margin-bottom: 90px;
    strong {
      display: block;
      font-weight: 700;
      margin-bottom: 15px;
    }
    p {
      font-size: 17px;
      line-height: 24px;
    }
  }
</style>